export default __webpack_public_path__ + "static/Ten_Cent-22040571af2ba347c832abd5f208b2a7.png";